export default __webpack_public_path__ + "static/Concept3-f7444deac99f3aeae3984b25a3cf0606.png";